import { useApi } from "@core/api";
import { useLocation, useNavigate } from "@remix-run/react";
import { useQuery } from "@tanstack/react-query";
import React from "react";

export const currentUserHookQueryKey = [ "currentUser" ];

export const useCurrentUser = () => {
  const api = useApi();
  const { pathname } = useLocation();
  const nav = useNavigate();

  const {
    data,
    ...rest
  } = useQuery({
    queryKey: currentUserHookQueryKey,
    queryFn: api["/auth/current"],
    refetchOnMount: true,
  });

  React.useEffect(() => {
    if (data?.RequirePasswordChange) {
      if (pathname !== "/password-reset") {
        nav("/password-reset");
      }
    }
  }, [ data, pathname, nav ]);

  return { user: data, ...rest };
};
